<template>
	<div class="vm--container" :style="styles">
		<div class="vm--overlay" />
		<div class="vm--modal">
			<div class="dialog" ref="wrapRef">
				<div class="dialog-title" v-if="title" v-html="title || ''" />

				<div class="dialog-content" v-if="type !== 'timer'">
					<div v-html="text || ''" />
				</div>

				<div class="dialog-content" v-else>
					<span>{{ frontMsg }}</span>
					<span style="color: #ed2024">{{ time }}</span>
					<span>{{ backMsg }}</span>
				</div>

				<div class="dialog-buttons" v-if="buttons.length">
					<button
						v-for="(button, index) in buttons"
						:class="['dialog-button', `type-${button.type || 'default'}`]"
						type="button"
						tabindex="0"
						:key="index"
						v-html="button.title"
						@click.stop="$emit('click', index)"
					>
						{{ button.title }}
					</button>
				</div>
				<div v-else class="dialog-buttons-none" />
			</div>
		</div>
	</div>
</template>

<script>
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';

export default {
	props: {
		type: {
			type: String,
		},
		frontMsg: {
			type: String,
		},
		time: {
			type: String,
		},
		backMsg: {
			type: String,
		},
		title: {
			type: String,
		},
		text: {
			type: String,
		},
		width: {
			type: [Number, String],
			default: 400,
		},
		clickToClose: {
			type: Boolean,
			default: true,
		},
		transition: {
			type: String,
		},
		buttons: {
			type: Array,
			default: () => [],
		},
		zIndex: Number,
	},

	computed: {
		styles() {
			return {
				zIndex: this.zIndex,
				/** 현재 다이얼로그가 열리기 전에 포커싱 되어있던 엘리먼트 */
				// preservedPrevElement: null,
			};
		},
	},

	mounted() {
		this.$nextTick(() => {
			disableBodyScroll(this.$refs.wrapRef);
			// this.preservedPrevElement = document.activeElement;
			this.$el.querySelector('.dialog-buttons button')?.focus?.();
		});
	},

	beforeDestroy() {
		// this.preservedPrevElement?.focus?.();
		enableBodyScroll(this.$refs.wrapRef);
	},
};
</script>

<style></style>
